"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexPreview = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/code-block/code-block");
require("@/components/common/flex/flex");
require("@/components/common/button/button-group");
require("@/components/common/toggle-button/toggle-button-group");
require("@/components/domains/ui-placeholder/ui-placeholder");
const DIRECTION_OPTIONS = [
    { value: 'row', label: 'row' },
    { value: 'column', label: 'column' },
];
const GAP_OPTIONS = [
    { value: '1', label: 'gap 1' },
    { value: '2', label: 'gap 2' },
    { value: '4', label: 'gap 4' },
];
const ITEM_COUNT = 3;
/** Container 문서에서 mm-flex의 direction·gap을 바꿔 가며 배치가 달라지는 모습을 보이는 예제. */
let FlexPreview = class FlexPreview extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.direction = 'row';
        this.gap = '2';
    }
    render() {
        return (0, lit_1.html) `
      <mm-button-group>
        <mm-toggle-button-group
          aria-label="direction"
          .options=${DIRECTION_OPTIONS}
          .value=${this.direction}
          @change=${this.handleDirectionChange}
        ></mm-toggle-button-group>
        <mm-toggle-button-group
          aria-label="gap"
          .options=${GAP_OPTIONS}
          .value=${this.gap}
          @change=${this.handleGapChange}
        ></mm-toggle-button-group>
      </mm-button-group>

      <mm-flex direction=${this.direction} gap=${this.gap} stretch>
        ${Array.from({ length: ITEM_COUNT }, () => (0, lit_1.html) `
            <mm-ui-placeholder></mm-ui-placeholder>
          `)}
      </mm-flex>

      <mm-code-block .code=${this.buildCode()}></mm-code-block>
    `;
    }
    handleDirectionChange(event) {
        this.direction = event.detail.value;
    }
    handleGapChange(event) {
        this.gap = event.detail.value;
    }
    /** row는 기본값이라 코드에 적지 않는다. */
    buildCode() {
        const direction = this.direction === 'row' ? '' : ` direction="${this.direction}"`;
        return `<mm-flex${direction} gap="${this.gap}">
  <!-- 항목 -->
</mm-flex>`;
    }
};
FlexPreview.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-3);
    }
  `;
__decorate([
    (0, decorators_js_1.state)()
], FlexPreview.prototype, "direction", void 0);
__decorate([
    (0, decorators_js_1.state)()
], FlexPreview.prototype, "gap", void 0);
FlexPreview = __decorate([
    (0, decorators_js_1.customElement)('mm-flex-preview')
], FlexPreview);
exports.FlexPreview = FlexPreview;
//# sourceMappingURL=data:application/json;base64,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